import { paperSizes } from '../../constants/print';

const store = {
    state: {
        reportPrintJob: null,
        pageFeedbackPrintStyleObject: null
    },
    mutations: {
        SET_PAGE_FEEDBACK_PRINT_SIZE_STYLE(state, paperSize) {
            const foundSize = paperSizes.find(
                (paperFormat) => paperFormat.name === paperSize
            );
            const rule = `@page {size: ${foundSize.name};}`;
            if (!state.pageFeedbackPrintStyleObject) {
                state.pageFeedbackPrintStyleObject = document.createElement('style');
                document.head.appendChild(state.pageFeedbackPrintStyleObject);
            }
            state.pageFeedbackPrintStyleObject.innerHTML = rule;
        },
        SET_REPORT_PRINT_JOB(state, printJob) {
            state.reportPrintJob = printJob;
        }
    },
    getters: {
        getReportPrintJob: (state) => state.reportPrintJob
    }
};

export default store;
